import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { updateUser } from '../actions/User';

class UserSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tack_min_speed_threshold: '',
            tack_entry_speed_filter: '',
            jibe_min_speed_threshold: '',
            jibe_entry_speed_filter: '',
            unit: '',
            wind_unit: '',
            map_speed_interval: '',
            map_distance_display: true,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        if (this.props.user) {
            this.setState({
                tack_min_speed_threshold: this.props.user.tack_min_speed_threshold || 20,
                tack_entry_speed_filter: this.props.user.tack_entry_speed_filter || 20,
                jibe_min_speed_threshold: this.props.user.jibe_min_speed_threshold || 20,
                jibe_entry_speed_filter: this.props.user.jibe_entry_speed_filter || 20,
                unit: this.props.user.unit || 'km/h',
                wind_unit: this.props.user.wind_unit || 'm/s',
                map_speed_interval: this.props.user.map_speed_interval || 200,
                map_distance_display: this.props.user.map_distance_display !== undefined ? this.props.user.map_distance_display : true,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.user !== prevProps.user && this.props.user) {
            this.setState({
                tack_min_speed_threshold: this.props.user.tack_min_speed_threshold || 20,
                tack_entry_speed_filter: this.props.user.tack_entry_speed_filter || 20,
                jibe_min_speed_threshold: this.props.user.jibe_min_speed_threshold || 20,
                jibe_entry_speed_filter: this.props.user.jibe_entry_speed_filter || 20,
                unit: this.props.user.unit || 'km/h',
                wind_unit: this.props.user.wind_unit || 'm/s',
                map_speed_interval: this.props.user.map_speed_interval || 200,
                map_distance_display: this.props.user.map_distance_display !== undefined ? this.props.user.map_distance_display : true,
            });
        }
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit(e) {
        e.preventDefault();
        const updatedUser = {
            ...this.props.user,
            tack_min_speed_threshold: parseFloat(this.state.tack_min_speed_threshold),
            tack_entry_speed_filter: parseFloat(this.state.tack_entry_speed_filter),
            jibe_min_speed_threshold: parseFloat(this.state.jibe_min_speed_threshold),
            jibe_entry_speed_filter: parseFloat(this.state.jibe_entry_speed_filter),
            unit: this.state.unit,
            wind_unit: this.state.wind_unit,
            map_speed_interval: parseInt(this.state.map_speed_interval, 10),
            map_distance_display: this.state.map_distance_display,
        };
        this.props.updateUser(updatedUser, this.props.history);
    }

    render() {
        return (
            <Container className="mt-5">
                <h2>Settings</h2>
                <Form onSubmit={this.handleSubmit}>
                    <h4 className="mt-4">Tack Analysis</h4>
                    <Form.Group as={Row} controlId="tackMinSpeed">
                        <Form.Label column sm={3}>Min Speed Threshold (km/h)</Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                type="number"
                                step="0.1"
                                name="tack_min_speed_threshold"
                                value={this.state.tack_min_speed_threshold}
                                onChange={this.handleChange}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="tackEntrySpeed">
                        <Form.Label column sm={3}>Entry Speed Filter (km/h)</Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                type="number"
                                step="0.1"
                                name="tack_entry_speed_filter"
                                value={this.state.tack_entry_speed_filter}
                                onChange={this.handleChange}
                            />
                        </Col>
                    </Form.Group>

                    <h4 className="mt-4">Jibe Analysis</h4>
                    <Form.Group as={Row} controlId="jibeMinSpeed">
                        <Form.Label column sm={3}>Min Speed Threshold (km/h)</Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                type="number"
                                step="0.1"
                                name="jibe_min_speed_threshold"
                                value={this.state.jibe_min_speed_threshold}
                                onChange={this.handleChange}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="jibeEntrySpeed">
                        <Form.Label column sm={3}>Entry Speed Filter (km/h)</Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                type="number"
                                step="0.1"
                                name="jibe_entry_speed_filter"
                                value={this.state.jibe_entry_speed_filter}
                                onChange={this.handleChange}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mt-4">
                        <Col sm={{ span: 9, offset: 3 }}>
                            <Button type="submit">Save Settings</Button>
                        </Col>
                    </Form.Group>

                    <h4 className="mt-4">Unit Settings</h4>
                    <Form.Group as={Row} controlId="speedUnit">
                        <Form.Label column sm={3}>Speed Unit</Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                as="select"
                                name="unit"
                                value={this.state.unit}
                                onChange={this.handleChange}
                            >
                                <option value="km/h">km/h</option>
                                <option value="knot">knot</option>
                            </Form.Control>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="windUnit">
                        <Form.Label column sm={3}>Wind Unit</Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                as="select"
                                name="wind_unit"
                                value={this.state.wind_unit}
                                onChange={this.handleChange}
                            >
                                <option value="m/s">m/s</option>
                                <option value="knot">knot</option>
                            </Form.Control>
                        </Col>
                    </Form.Group>

                    <h4 className="mt-4">Map Display Settings</h4>
                    <Form.Group as={Row} controlId="mapSpeedInterval">
                        <Form.Label column sm={3}>Speed Display Interval (m)</Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                type="number"
                                step="10"
                                name="map_speed_interval"
                                value={this.state.map_speed_interval}
                                onChange={this.handleChange}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="mapDistanceDisplay">
                        <Form.Label column sm={3}>Show Distance on Map</Form.Label>
                        <Col sm={9} className="d-flex align-items-center">
                            <Form.Check
                                type="checkbox"
                                name="map_distance_display"
                                checked={this.state.map_distance_display}
                                onChange={(e) => this.setState({ map_distance_display: e.target.checked })}
                                label="Show distances"
                            />
                        </Col>
                    </Form.Group>
                </Form>
            </Container>
        );
    }
}

const mapStateToProps = state => ({
    user: state.auth.user,
    token: state.auth.token,
});

const mapDispatchToProps = dispatch => ({
    updateUser: (user, history) => dispatch(updateUser(user, history)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserSettings);
